import { TractorVariantIcon } from './TractorVariantIcon';

/**
 * author: Google
 * id C80B9924-A19D-440E-8543-E1E232FAA90B
 * name tractor-variant
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tractor-variant.svg
 * tags
 * - Agriculture 
 */
export const AgricultureIcon = TractorVariantIcon;
export default AgricultureIcon